import HttpCliente from "../HttpCliente";

export const getHorariosEnvioScraper = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/HorarioEnvioScraper", {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
      .then((r) => resolve(r.data))
      .catch(reject);
  });
};

export const crearHorariosEnvioScraper = (token, data) => {
  // data: { dias: [0,1,2], horaEnvio: "14:00:00" }
  return new Promise((resolve, reject) => {
    HttpCliente.post("/HorarioEnvioScraper", data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((r) => resolve(r.data))
      .catch(reject);
  });
};

export const eliminarHorarioEnvioScraper = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/HorarioEnvioScraper/${id}`, {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
      .then((r) => resolve(r.data))
      .catch(reject);
  });
};

export const eliminarHorariosEnvioScraper = (token, ids) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete("/HorarioEnvioScraper", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: { ids },
    })
      .then((r) => resolve(r.data))
      .catch(reject);
  });
};